export default "__VITE_ASSET__CgWHfCNB__"